import { useTranslation } from '@sm360/hooks'
import { InputCurrency } from '@sm360/ui-library'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'

import { Context } from '../../../../configs/state.manager'
import { FREQUENCY_LABEL } from '../../../../dummies/card.dummies'

const InvoiceTotal = ({ slug, label, amount }) => {
    const {
        state: {
            dealerInfos: { lang },
            paymentOptions: { purchaseMethod, paymentFrequency, finance, term },
        },
    } = React.useContext(Context)

    const { t } = useTranslation()

    const classNames = clsx('pc-invoiceTotal', slug && `-${slug}`, '-card')

    if (purchaseMethod === 'cash') {
        return (
            <div className={classNames}>
                <div className='pc-invoiceTotal__detail'>
                    <span className='pc-invoiceTotal__label'>{label}</span>

                    <span className='pc-invoiceTotal__value'>
                        <InputCurrency id={slug} name={slug} value={amount} displayAsText displayWithTwoDecimals locale={lang} />
                    </span>
                </div>
            </div>
        )
    }

    const { payment, apr } = finance?.term || {}

    return (
        <div className={classNames}>
            <div className='pc-invoiceTotal__detail'>
                <span className='pc-invoiceTotal__label'>{label}</span>

                <span className='pc-invoiceTotal__value'>
                    <InputCurrency id={slug} name={slug} value={amount} displayAsText displayWithTwoDecimals locale={lang} />
                </span>
            </div>

            <div className='pc-invoiceTotal__resume'>
                <span className='pc-invoiceTotal__label'>{t('pc.targetPaymentAmount')}</span>

                <span className='pc-invoiceTotal__value'>
                    <InputCurrency id={slug} name={slug} value={payment} displayAsText displayWithTwoDecimals locale={lang} />
                    {t(`pc.byPaymentFrequency.${paymentFrequency}`)}
                </span>
            </div>

            <div className='pc-invoiceTotal__resume'>
                <span className='pc-invoiceTotal__label'>{t('pc.rate')}</span>

                <span className='pc-invoiceTotal__value'>{apr}%</span>
            </div>

            <div className='pc-invoiceTotal__resume'>
                <span className='pc-invoiceTotal__label'>{t('pc.term')}</span>

                <span className='pc-invoiceTotal__value'>{t('pc.termByMonths', { term })}</span>
            </div>
        </div>
    )
}

InvoiceTotal.propTypes = {
    slug: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    amount: PropTypes.number,
}

InvoiceTotal.defaultProps = {
    slug: '',
    label: '',
    amount: null,
}

export default InvoiceTotal
